import { ringEnabled } from '../store/features/ringDefinitions';
import type { LogicalRing } from 'owa-config';

// let's get all the features that define a ring and return an object
// if that ring matches the ring that is passed in
export function getFlagsEnabledByRing(ring: LogicalRing) {
    return Object.keys(ringEnabled).reduce((agg, f) => {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS7053 (11,9): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        // @ts-expect-error
        agg[f.toLowerCase()] = ringEnabled[f].ring.indexOf(ring) > -1;
        return agg;
    }, {});
}
